import PropTypes from 'prop-types';
import cx from "ramda-extension/es/cx";
import React from 'react';
import { useDefaultComponentValue } from '../../../utils/useDefaultComponentValue';
const COMPONENT_NAME = 'Progress';
const Progress = (inProps)=>{
    const props = useDefaultComponentValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { className, children, ...other } = props;
    return /*#__PURE__*/ React.createElement("span", {
        className: cx('Progress', className),
        ...other
    }, children);
};
Progress.propTypes = {
    /**
	 * Children define content inside Progress
	 */ children: PropTypes.any,
    /**
	 * Custom `className` for the root.
	 */ className: PropTypes.string
};
export default Progress;
